module.exports = __webpack_public_path__ + "static/media/Hand Of God (Outro).6bcf612d.mp3";